// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__1MOL-","name":"Header_name__26S28","links":"Header_links__tVK5o","link":"Header_link__2bYEV"};